import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const API_URL = (typeof window !== "undefined" && window.location ? window.location.origin : process.env.REACT_APP_BACKEND_URL) || '';

const Footer = ({ className = '', academyName = null }) => {
  const currentYear = new Date().getFullYear();
  const [businessName, setBusinessName] = useState(academyName || '');
  const [isLoading, setIsLoading] = useState(!academyName);
  
  useEffect(() => {
    if (!academyName) {
      // Fetch business name if not provided
      const fetchBusinessName = async () => {
        try {
          const response = await fetch(`${API_URL}/api/contact-info`);
          if (response.ok) {
            const data = await response.json();
            if (data.business_name) {
              setBusinessName(data.business_name);
            }
          }
        } catch (error) {
          console.error('Error fetching business name:', error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchBusinessName();
    }
  }, [academyName]);
  
  const legalLinks = [
    { path: '/privacy-policy', label: 'Privacy Policy' },
    { path: '/terms-of-service', label: 'Terms of Service' },
    { path: '/shipping-policy', label: 'Shipping Policy' },
    { path: '/return-refund-policy', label: 'Returns & Refunds' },
    { path: '/do-not-sell-info', label: 'Do Not Sell My Info' }
  ];

  return (
    <footer className={`bg-slate-50 border-t border-slate-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Copyright */}
          <div className="text-sm text-slate-500">
            © {currentYear} {businessName || (isLoading ? '' : 'Cricket Academy')}. All rights reserved.
          </div>
          
          {/* Legal Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {legalLinks.map((link, index) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-sm text-slate-500 hover:text-slate-700 transition-colors"
                data-testid={`footer-link-${index}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

// Compact version for dashboard layouts
export const CompactFooter = ({ className = '', academyName = null }) => {
  const currentYear = new Date().getFullYear();
  const [businessName, setBusinessName] = useState(academyName || '');
  const [isLoading, setIsLoading] = useState(!academyName);
  
  useEffect(() => {
    if (!academyName) {
      // Fetch business name if not provided
      const fetchBusinessName = async () => {
        try {
          const response = await fetch(`${API_URL}/api/contact-info`);
          if (response.ok) {
            const data = await response.json();
            if (data.business_name) {
              setBusinessName(data.business_name);
            }
          }
        } catch (error) {
          console.error('Error fetching business name:', error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchBusinessName();
    }
  }, [academyName]);
  
  const legalLinks = [
    { path: '/privacy-policy', label: 'Privacy' },
    { path: '/terms-of-service', label: 'Terms' },
    { path: '/do-not-sell-info', label: 'Do Not Sell' }
  ];

  return (
    <footer className={`border-t border-slate-200 bg-white ${className}`}>
      <div className="px-4 py-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-slate-400">
        <span>© {currentYear} {businessName || (isLoading ? '' : 'Cricket Academy')}</span>
        <span className="hidden sm:inline">•</span>
        {legalLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className="hover:text-slate-600 transition-colors"
          >
            {link.label}
          </Link>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
